import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import {
  MotifButton,
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifRadioButton,
  MotifRadioButtonGroup,
} from '@ey-xd/motif-react';
import * as Constants from '../../constants/other';

const BulkSignOffModal = ({
  showSignOffModal,
  toggleShowSignOffModal,
  handleSignOffSave,
  resetSignOffRadioButtons,
  currentUserIsEngagementUser,
}) => {
  const [selectedOption, setSelectedOption] = useState('');

  useEffect(() => {
    setSelectedOption('');
  }, [resetSignOffRadioButtons]);

  return (
    <MotifModal
      show={showSignOffModal}
      onClose={toggleShowSignOffModal}
      variant="alt"
    >
      <MotifModalHeader data-testid="mdHdrUpdateSignOffStatus">
        Update Sign Off Status
      </MotifModalHeader>
      <MotifModalBody>
        <h6>
          Please select sign off status for selected REIT(s) and report period
        </h6>
        <br></br>
        <div>
          <MotifRadioButtonGroup>
            {Constants.updateSignOffStatusAction.map((array) => (
              <MotifRadioButton
                name="signOff"
                id={array.value}
                value={array.value}
                checked={selectedOption === array.value}
                disabled={array.type == 'reopen' && currentUserIsEngagementUser}
                onChange={(event) => setSelectedOption(event.target.value)}
                data-testid={'rb' + array.text.replace(/\s+/g, '')}
              >
                {array.text}
              </MotifRadioButton>
            ))}
          </MotifRadioButtonGroup>
        </div>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          variant="secondary"
          className="right"
          type="button"
          onClick={toggleShowSignOffModal}
          data-testid="btnCancel"
        >
          Cancel
        </MotifButton>
        <MotifButton
          variant="primary"
          className="right"
          type="button"
          onClick={() => handleSignOffSave(selectedOption)}
          data-testid="btnSave"
          disabled={selectedOption == ''}
        >
          Save
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};

BulkSignOffModal.propTypes = {
  showSignOffModal: PropTypes.bool,
  toggleShowSignOffModal: PropTypes.func,
  handleSignOffSave: PropTypes.func,
  resetSignOffRadioButtons: PropTypes.bool,
  currentUserIsEngagementUser: PropTypes.bool,
};

export default BulkSignOffModal;
